import React, { ReactNode } from 'react';
import { Flex, Heading, Box, Center, Link } from '@chakra-ui/react';
import { Footer } from '../../atoms';
import { ThemedImage } from '@send-legacy-components/Common';
import { useFeature } from '@sendpayments/react-shared/hooks/useFeature'; // can be removed in the future
import { PD_4823_REBRANDING_2025 } from '@sendpayments/shared-constants/features'; // can be removed in the future

interface AuthenticationTemplateProps {
  heading?: string;
  children: ReactNode;
}

const AuthenticationTemplate: React.FC<AuthenticationTemplateProps> = ({ heading = '', children }) => {
  const [
    {
      data: { isEnabled: isRebrandActive },
    },
  ] = useFeature({
    feature: PD_4823_REBRANDING_2025,
    activeValue: undefined,
    functionName: `Captcha`,
    defaultValue: undefined,
  });

  const ThemedImageJSX = () => {
    return isRebrandActive ? (
      <ThemedImage alt="logo" file="updated_logo.svg" path={null} />
    ) : (
      <ThemedImage alt="logo" file="logo.svg" path={null} />
    );
  };
  return (
    <Flex
      minH="100vh"
      backgroundImage={{ base: 'none', lg: "url('/static/images/background.jpg')" }}
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      backgroundSize="contain"
      backgroundBlendMode="multiply"
      backgroundColor={{ base: 'none', lg: 'rgba(0, 0, 0, 0.5)' }}
      p={{ base: 4, lg: 8 }}
      direction="column"
    >
      <Link to="/login" className="logo">
        <ThemedImageJSX />{' '}
      </Link>
      <Center pt={{ base: 20, lg: '80px' }}>
        <Box bg="white" borderRadius={8} p={{ base: 0, md: '49' }} w="100%" maxW="514px">
          <Heading as="h2" variant="heading2" mb={1} fontSize={36} textAlign="center" lineHeight="44px" color="#1B2221">
            {heading}
          </Heading>
          {children}
          <Footer mt={4} />
        </Box>
      </Center>
    </Flex>
  );
};

export { AuthenticationTemplate, AuthenticationTemplateProps };
